import React, { useState, useEffect } from 'react';
import '../styles/Home.css';
import { Link } from 'react-router-dom';

const Home = () => {
    const calculateTimeLeft = () => {
        const eventDate = new Date("April 18, 2025 11:00:00").getTime();
        const now = new Date().getTime();
        const difference = eventDate - now;

        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
                seconds: Math.floor((difference % (1000 * 60)) / 1000),
            };
        } else {
            timeLeft = {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
            };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className="home">
            <div className="reunion-header">
                <h1 className="reunion-title">Underhill Family Reunion</h1>
                <p className="reunion-date">Cary, NC - April 18-20, 2025</p>
                <img src={require('../images/reunionlogo.PNG')} alt="Underhill Family Reunion Logo" className="reunion-logo" />
                <a href="https://www.hilton.com/en/attend-my-event/2025underhillfamilyreunion/" target="_blank" rel="noopener noreferrer">
                    <button className="book-room-button">Click Here To Book A Room</button>
                </a>

                {/* Countdown Clock */}
                <div className="countdown">
                    <h2>Countdown to Reunion</h2>
                    <div className="countdown-timer">
                        <span>{timeLeft.days} Days</span> :
                        <span>{timeLeft.hours} Hours</span> :
                        <span>{timeLeft.minutes} Minutes</span> :
                        <span>{timeLeft.seconds} Seconds</span>
                    </div>
                </div>

                <div className="container mt-4">
                    <div className="card shadow announcement-box">
                        <div className="card-body">
                            <p className="announcement">
                                Hello Underhill Family,<br /><br />
                                We are thrilled to announce the host hotel for the upcoming 2025 Underhill Family Reunion in Cary, NC! To ensure everyone has a comfortable stay, we've secured a block of rooms at a special group rate. Early arrivals are welcome, with room availability starting from Thursday, April 17, 2025.<br /><br />
                                Please note that we have a limited number of rooms reserved, so be sure to book yours early to secure your spot. We can't wait to gather and celebrate with you all!<br /><br />
                                Warm regards,<br />
                                Underhill Family Reunion Committee
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Embassy Suites by Hilton Section */}
            <div className="hotel-info">
 

                {/* Embed the video here */}
                <div className="video-container">
                    <iframe
                        src="https://atriumhospitalitywrnz0g.hippovideo.io/page/cary-embassy-suites_a231c18a?custom_asset_token=mZn5zFdBEzirEA5UKACDRsQDCjhVuu37f6Mxw_NlOdo&"
                        width="1000"
                        height="1000"
                        allowFullScreen
                        style={{ border: 'none' }}>
                    </iframe>
                </div>
            </div>


            <div className="family-reunion">
                <div className="room-rates">
                    <h2>Room Rates</h2>
                    <p>
                        Room Suite-1 King Bed or 2 Double Beds - nonsmoking<br />
                        Single Occupancy - $169.00<br />
                        Double Occupancy - $169.00<br />
                        Last day to book a room at the discounted rate is March 11, 2025.<br />
                    </p>
                    <br/>

                    <h3>Complimentary Hotel Amenities:</h3>
                    <ul className="no-bullets">
                        <li>Complimentary WiFi in guest rooms</li>
                        <li>Complimentary hot breakfast buffet with made-to-order omelette station</li>
                        <li><strong>Hotel breakfast for guests staying at the hotel only</strong></li>
                        <li>Complimentary nightly manager's reception from 6:00 PM - 7:30 PM</li>
                        <li>Hotel Bar and restaurant open from 3:00 PM - 11:00 PM (Friday and Saturday)</li>
                        <li>Complimentary hotel shuttle to the airport only</li>
                        <li>All-suites hotel with pullout sofa bed in separate living room area</li>
                        <li>Indoor saltwater pool</li>
                        <li>Pickleball and basketball</li>
                    </ul>
                    <br />

                    <h3>Family Reunion Registration Package Prices:</h3>
                    <p>All packages include all meals, rush hour karting activities, and a t-shirt.</p>
                    <ul className="no-bullets">
                        <li><strong>Adults (18 and up):</strong> $200</li>
                        <li><strong>Children (12-17):</strong> $100</li>
                        <li><strong>Kids (6-11):</strong> $50</li>
                        <li><strong>Under 6:</strong> Free</li>
                    </ul>
                    <br />

                    <h3>A La Carte Items:</h3>
                    <ul className="no-bullets">
                        <li>Welcome Dinner only: $50</li>
                        <li> <a href="https://rushhourkarting.com/rtp/" target="_blank" rel="noopener noreferrer">Rush Hour Karting</a> only: $40</li>
                        <li>Family Banquet: $70</li>
                        <li>Sunday Resurrection Dinner: $30</li>
                        <li>T-Shirt: $25</li>
                    </ul>
                    <br />

                    <h3>Traveling Tips:</h3>
                    <ul className="no-bullets">
                        <li>Remember to book your room early to secure the discounted rate.</li>
                        <li>Explore the hotel's amenities and plan some family activities during your stay.</li>
                    </ul>
                    <br />

                    <p><strong>Contact <Link to="/ContactUs">Sherri Richardson</Link> about additional inquiries.</strong></p>
                </div>
            </div>

            {/* 2025 Reunion Schedule Section */}
            <div className="schedule-container">
                <div className="reunion-schedule">
                    <h2>2025 Reunion Schedule</h2>
                    <h3>Embassy Suites by Hilton Raleigh Durham Research Triangle</h3>
                    <p>201 Harrison Oaks Boulevard, Cary, North Carolina, 27513, USA</p>

                    <h3>Thursday, April 17, 2025</h3>
                    <p>Early Arrivals - Enjoy local attractions on your own.</p>
                    <p>6:00 - 7:30 PM: Complimentary Managers Reception for registered hotel guests.</p>

                    <h3>Friday, April 18, 2025</h3>
                    <p>Complimentary Hotel Breakfast: 6:00 AM - 9:00 AM</p>
                    <p>4 PM: Hotel Check-In (Early Check-in is $25 no-exceptions)</p>
                    <p>12 PM - 5 PM: Family Vendor Tables and Registration Check-In</p>
                    <p>6:00 PM - 7:30 PM: Complimentary Managers Reception for registered hotel guests.</p>
                    <p>7 PM - 12 AM: Meet & Greet/Welcome Dinner</p>
                    <p>7 PM - 8:30 PM: Dinner Buffet (Triangle Ballroom, attire: casual)</p>
                    <p>Menu: BBQ Buffet (baked BBQ chicken, BBQ ribs, fried catfish, garden salad, potato salad, coleslaw, macaroni and cheese, hush puppies, corn medley, cornbread, banana pudding, strawberry shortcake, coffee & sweet tea)</p>

                    <h3>Saturday, April 19, 2025</h3>
                    <p>Complimentary Hotel Breakfast for registered hotel guests: 7:30 AM - 10:30 AM</p>
                    <p>8:30 AM - 9:30 AM: Family Breakfast</p>
                    <p>9:30 AM - 10:30 AM: Hip-Hop Cardio w/ Alex in Triangle Ballroom</p>
                    <p>11:00 AM - 2:00 PM: Rush Hour Karting (lunch and unlimited arcades included)</p>
                    <p>6:00 PM - 7:30 PM: Complimentary Managers Reception for registered hotel guests.</p>
                    <p>7:00 PM - 8:30 PM: Family/Friends Dinner Banquet (attire: dressy/after-five; no jeans)</p>
                    <p>Doors will open at 6:30 PM, dinner will be served at 7:00 PM</p>
                    <p>Menu: Adults (grilled chicken tortellini, crispy seared salmon, meatloaf, fruit salad, house salad, broccoli salad, garlic whipped mashed potatoes, mixed vegetables, rolls w/ butter, assorted cakes and cheesecake) and Children (chicken tenders w/ honey mustard and BBQ sauce, french fries and fruit cup)</p>
                    <p>9 PM - 12 AM: Family Shenanigans (Fellowship/Games/Dancing/Karaoke)</p>

                    <h3>Sunday, April 20, 2025</h3>
                    <p>Complimentary Hotel Breakfast for registered hotel guests: 7:30 AM - 10:30 AM</p>
                    <p>8:00 AM - 9:00 AM: Family Breakfast</p>
                    <p>10:00AM - 11:00 AM: Farewell / Worship Service</p>
                    <p>11:00 AM: Hotel Check Out & Departures</p>

                    <h3>Sunday Resurrection Dinner/Easter Egg Hunt</h3>
                    <p>3:00 PM - 6:00 PM at Mary Ann and Marlon's House (4559 Aaron Lane, Elm City, NC)</p>
                    <p>Menu: Grilled Pork Chops, Fried Chicken, Corn on the cob, Green Beans, Collards, Rice and Gravy, Yams, Mac and Cheese, Dessert, Punch</p>
                </div>
            </div>
        </div>
    );
};

export default Home;

